import Oidc from 'oidc-client';

/** Oidc Login
* @constructor
* @param {string} managerConfig - 設定檔
*/
export default class AuthManager {
  constructor() {
    this.PROMPT = 'select_account';
  }

  /** 初始化 Oidc manager
  */
  initManager(config) {
    Oidc.Log.logger = console;
    // 設定 => DEBUG 可以看記錄情況 , NONE 不印出任何 DEBUG 訊息
    Oidc.Log.level = Oidc.Log.NONE;
    this.manager = new Oidc.UserManager(config);
  }

  /** 處理刷新token錯誤
  * @param {function} errorCallback - 處理刷新 token error callback
  */
  handleSilentRenewError(errorCallback) {
    // 刷新失敗 則 刪除此裝置的使用者、查同裝置上其他平台是否有登入情況
    this.manager.removeUser();
    this.manager.signinSilent()
      .catch((error) => {
        console.log(error.message);
        if (errorCallback) errorCallback();
      });
  }

  /** Oidc.Manager的事件處理
  * @param {function} renewTokensErrorCallback - 處理刷新 token error callback
  * @param {function} renewTokens - 更新 tokens 的方法
  */
  setOidcManagerEvents(vm, renewTokensErrorCallback, renewTokens) {
    // oidc-client 協助 refresh_token 事件處理 => 取得最新的 tokens
    this.manager.events.addUserLoaded(async (response) => {
      // @const {Object} userRenewTokens 使用者目前最新的tokens
      const userRenewTokens = {
        at: response.access_token,
        idt: response.id_token,
        rt: response.refresh_token,
      };
      if (renewTokens) renewTokens(userRenewTokens);
      // 取得最新的tokens時，cookie裡也存一份(期限為一天)
      vm.$cookies.set('cm_at', userRenewTokens.at, {
        domain: window.location.hostname,
        path: '/',
        secure: true,
        sameSite: 'Lax',
        maxAge: 60 * 60 * 24,
      });
    });
    // oidc-client 登出事件處理 若同一裝置上有網站登出，所有網站都會一起登出
    this.manager.events.addUserSignedOut(() => {
      this.manager.removeUser()
        .then(() => this.manager.signinSilent())
        .catch((error) => {
          console.log(error.message);
        });
    });
    // oidc-client access_token 過期 則 先嘗試刷新 token
    this.manager.events.addAccessTokenExpired(() => {
      this.manager.signinSilent()
        .catch(() => {
          this.handleSilentRenewError(renewTokensErrorCallback);
        });
    });
    // oidc-client 刷新token錯誤事件處理
    this.manager.events.addSilentRenewError(() => {
      this.handleSilentRenewError(renewTokensErrorCallback);
    });
  }
}
